<template>
  <div class="line-broadcast-accordion">
    <div class="line-broadcast-accordion_trigger" @click="handleOnClick">
      <div class="accordion-header" @click.stop>
        <slot name="accordion-header"></slot>
      </div>
      <i :class="`bx ${collapseState ? 'bx-chevron-down' : 'bx-chevron-up'}`" />
    </div>
    <div v-if="!collapseState" class="line-broadcast-accordion_expand-content">
      <slot name="accordion-content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LineBroadcastAccordion',
  props: {
    isControlled: {
      // This prop is 'true' when the collapse behavior is fully managed by the parent.
      type: Boolean,
      default: false,
    },
    isCollapsed: {
      // IsCollapsed controls the standard accordion behavior
      type: Boolean,
    },
  },
  data() {
    return {
      // use when isControlled is false.
      isInternalCollapsed: true,
    };
  },
  computed: {
    collapseState() {
      if (this.isControlled) {
        return this.isCollapsed;
      }
      return this.isInternalCollapsed;
    },
  },
  methods: {
    handleOnClick() {
      if (this.isControlled) {
        // Use this when the collapse behavior is managed by the parent.
        this.$emit('on-click-accordion-header', !this.isCollapsed);
        return;
      }
      this.isInternalCollapsed = !this.isInternalCollapsed;
    },
  },
};
</script>
<style lang="scss" scoped>
.line-broadcast-accordion {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  i {
    color: #4b5178;
    font-size: 20px;
  }
  &_trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .accordion-header {
      margin-right: 8px;
      user-select: none;
    }
  }
  &_expand-content {
    display: flex;
    flex-direction: column;
  }
}
</style>
